import S3 from "aws-s3";

import * as actionTypes from "./actionTypes";
import * as urls from "../../utils/urls";

import api from "../../services";
import axios from "axios";

import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";

import { getUserData, updateUserData } from "../../utils/localStorage";
import { setAppointmentData } from "./appointmentActions";

import {
  parseDateToLocal,
  parseDateToUTC,
  parseTimeToLocal,
  parseTimeToUTC,
} from "../../utils/parseDateTime";
import messages from "../../constants/messages";
import { authInit } from "./authActions";
import constants, { getOnboardingPath } from "../../constants";
import { setAccountDetails } from "./bankAccount";

import { UsaStates } from "usa-states";
import { updateClinicianProfile } from ".";

export const setPersonalInfo = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_PERSONAL_INFO,
      payload,
    });
};

export const setPracticeDetails = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_PRACTICE_DETAILS,
      payload,
    });
};

export const addSlots = (period, calId) => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_SLOTS,
      payload: { period, calId },
    });
};

export const setSlots = (period, data, index, calId) => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_SLOTS,
      payload: { period, data, index, calId },
    });
};

export const removeSlots = (period, index, calId) => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_SLOTS,
      payload: { period, index, calId },
    });
};

export const addWorkingDays = (data, calId) => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_WORKING_DAYS,
      payload: { data, calId },
    });
};

export const addAcceptUntil = (data, calId, date) => {
  return dispatch => {
    dispatch({
      type: actionTypes.ADD_ACCEPT_UNTIL,
      payload: { data, calId, date },
    });
  };
};

export const addCalendar = () => {
  return dispatch =>
    dispatch({
      type: actionTypes.ADD_CALENDAR,
    });
};

export const removeCalendar = calId => {
  return dispatch =>
    dispatch({
      type: actionTypes.REMOVE_CALENDAR,
      payload: { calId },
    });
};

export const setDocuments = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_DOCUMENTS,
      payload,
    });
};

export const setPersonalisedExperience = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_PERSONALISE_EXPERIENCE,
      payload,
    });
};

export const updateUserId = id => {
  return dispatch => {
    updateUserData({
      id,
    });
    dispatch({
      type: actionTypes.AUTH_SUCCESS,
    });
  };
};

export const getSpecialityList = () => {
  return dispatch => {
    dispatch(apiStart());
    api
      .getSpecialityList()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          let optionsArr = [];
          res.data[0].map(speciality =>
            optionsArr.push({
              label: speciality.speciality,
              value: speciality.speciality,
            })
          );
          dispatch(
            setPersonalInfo({
              specialitiesOptions: optionsArr,
              dataChanged: false,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getLanguageList = () => {
  return dispatch => {
    dispatch(apiStart());
    api
      .getLanguageList()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          let optionsArr = [];
          res.data[0].map(language =>
            optionsArr.push({
              label: language.language,
              value: language.language,
            })
          );
          dispatch(
            setPersonalInfo({
              languagesOptions: optionsArr,
              dataChanged: false,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getEducationalList = cb => {
  return dispatch => {
    dispatch(apiStart());
    api
      .getEducationalList()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          let optionsArr = [];
          res.data[0].map(degree =>
            optionsArr.push({
              id: degree.id,
              label: degree.degree,
              value: degree.degree,
            })
          );
          dispatch(
            setPersonalInfo({
              educationalOptions: optionsArr,
              dataChanged: false,
            })
          );
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getDoctorAppTheme = () => {
  return dispatch => {
    const userData = getUserData();

    dispatch(apiStart());
    axios
      .get(urls.getDoctorAppThemeUrl(userData?.id))
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const data = res.data[0][0];
          data &&
            dispatch(
              setPersonalisedExperience({
                id: data.id,
                selectedThemeId: data.app_theme,
                theme_name: data.theme_name,
                theme_color: data.theme_color,
                logo: data?.logo_url && [
                  {
                    src: data?.logo_url,
                  },
                ],
              })
            );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const saveDoctorDetails = cb => {
  return (dispatch, getState) => {
    const personalDetails = getState().onboarding.personalInfo;
    const payload = {
      gender: personalDetails.gender,
      add_speciality: [
        personalDetails.specialities.map(specialities => specialities.label),
      ][0],
      years_of_experience: personalDetails.yearsOfExperience,
      about_me: personalDetails.aboutMe ? personalDetails.aboutMe : null,
      add_language: [
        personalDetails.languages.map(language => language.label),
      ][0],
      add_degree: [personalDetails.degree.id],
      date_of_birth: parseDateToUTC(personalDetails.date_of_birth),
      doctor_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    dispatch(apiStart());

    const userPayload = {
      first_name: personalDetails.firstName,
      last_name: personalDetails.lastName,
    };
    axios
      .patch(urls.updateUserUrl(getUserData().user), userPayload)
      .then(userResponse => {
        const userRes = userResponse.data;
        if (userRes.status_code === 200) {
          dispatch(apiStart());
          axios
            .post(urls.saveDoctorDetailsUrl, payload)
            .then(response => {
              const res = response.data;
              if (res.status_code === 200) {
                dispatch(getDoctorDetails());

                dispatch(updateUserId(res.data.id));
                cb();
              } else {
                errorHandler(res.message[0]);
              }
              dispatch(apiSuccess());
            })
            .catch(error => {
              catchHandler(error, dispatch);
            });
        } else {
          errorHandler(userRes.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

const sortCalendarByDate = (a, b) => {
  if (a?.startDate > b?.startDate) {
    return 1;
  }
  if (a?.startDate < b?.startDate) {
    return -1;
  }
  return 0;
};

const getCountryState = abrState => {
  const stateObj = new UsaStates()?.states?.filter(
    state => state.abbreviation === abrState
  )[0];
  return {
    label: stateObj?.name,
    value: stateObj?.abbreviation,
  };
};

export const getDoctorDetails = (flag, cb = () => {}) => {
  return (dispatch, getState) => {
    if (flag === "init") {
      dispatch(apiStart(true));
    } else {
      dispatch(apiStart(false));
    }

    axios
      .get(urls.getDoctorDetailsUrl)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          if (res.data) {
            const detailsObj = res.data[0][0];

            updateUserData({
              firstName: detailsObj.first_name,
              lastName: detailsObj.last_name,
              doctor_subscription_details:
                detailsObj?.doctor_subscription_details,
              qrcode_url: detailsObj?.qrcode_url,
            });

            const personalDetails = {
              photo: { src: detailsObj.image },
              aboutMe: detailsObj.about_me,
              degree: {
                id: detailsObj.degree[0].id,
                label: detailsObj.degree[0].degree,
                value: detailsObj.degree[0].degree,
              },
              firstName: detailsObj.first_name,
              lastName: detailsObj.last_name,
              specialities: [
                detailsObj.speciality.map(speciality => ({
                  label: speciality,
                  value: speciality,
                })),
              ][0],
              languages: [
                detailsObj.language.map(language => ({
                  label: language,
                  value: language,
                })),
              ][0],
              yearsOfExperience: detailsObj.years_of_experience,
              date_of_birth: new Date(
                parseDateToLocal(detailsObj.date_of_birth)
              ),
              gender: detailsObj.gender,
              dosespot_id: detailsObj?.dosespot_id,
              dataLoaded: true,
              dataChanged: false,
              docsignature: detailsObj?.signature && [
                {
                  src: detailsObj?.signature,
                },
              ],
              doctor_subscription_details:
                detailsObj?.doctor_subscription_details,
              qrcode_url: detailsObj?.qrcode_url,
            };

            const personalDetail = {
              ...personalDetails,
              copy: personalDetails,
            };

            const practiceDetailsObj = detailsObj.practice_details;

            const documentsObj = detailsObj.doctor_documents[0];

            const bankDetailsObj = detailsObj.doctor_bank_details;

            if (
              practiceDetailsObj &&
              Object.keys(practiceDetailsObj).length > 0
            ) {
              const calendar = [];

              practiceDetailsObj.doctor_availability.forEach(availiability => {
                const morningSlots = [];
                const afternoonSlots = [];
                const eveningSlots = [];

                availiability.slots.forEach(slot => {
                  const start_with_date = parseTimeToLocal(
                    slot.start_time,
                    availiability.start_date
                  );

                  const end_with_date = parseTimeToLocal(
                    slot.end_time,
                    availiability.start_date
                  );

                  const startTime = parseTimeToLocal(
                    slot.start_time,
                    availiability.start_date
                  ).split(":");

                  const endTime = parseTimeToLocal(
                    slot.end_time,
                    availiability.start_date
                  ).split(":");

                  const slt = {
                    id: slot.id,
                    startTime: {
                      hour: parseInt(startTime[0]),
                      minutes: parseInt(startTime[1]),
                    },
                    endTime: {
                      hour: parseInt(endTime[0]),
                      minutes: parseInt(endTime[1]),
                    },
                    duration: {
                      label: slot.slot_duration,
                      value: parseInt(slot.slot_duration.split(" ")[0]),
                    },
                  };

                  if (start_with_date >= "00:00" && end_with_date <= "12:00") {
                    morningSlots.push(slt);
                  } else if (
                    start_with_date >= "12:00" &&
                    end_with_date <= "18:00"
                  ) {
                    afternoonSlots.push(slt);
                  } else {
                    eveningSlots.push(slt);
                  }
                });

                const weekDays = availiability.week_days.map(day =>
                  parseInt(day)
                );

                const obj = {
                  startDate: parseDateToLocal(availiability.start_date),
                  endDate: parseDateToLocal(availiability.end_date),
                  morningSlots: morningSlots,
                  afternoonSlots: afternoonSlots,
                  eveningSlots: eveningSlots,
                  workingDays: weekDays,
                  id: availiability.id,
                };
                calendar.push(obj);
              });

              calendar.sort(sortCalendarByDate);

              const addressObj = practiceDetailsObj.practice_address;

              const practiceDetails = {
                practice_detail: practiceDetailsObj.id,
                fees: practiceDetailsObj.fees,
                primaryPhone: practiceDetailsObj.primary_phone,
                primaryPhoneType: constants.PRIMARY_PHONE_TYPES.filter(
                  type => type.value === practiceDetailsObj.primary_phone_type
                )[0],
                primaryFax: practiceDetailsObj.primary_fax,
                practiceName: practiceDetailsObj.practice_name,
                slotTimezone: practiceDetailsObj.slot_timezone,
                calendar: calendar,
                address_id: addressObj.id,
                address1: addressObj.address1,
                address2: addressObj.address2,
                city: addressObj.city,
                country: addressObj.country,
                state: addressObj.state,
                zipcode: addressObj.zip_code,
                latitude: addressObj.latitude,
                longitude: addressObj.longitude,
                dataLoaded: true,
                removedCalendar: [],
                removedSlots: [],
                doctorUnavailability: detailsObj.doctor_unavailability,
                engagedSlots: detailsObj.engaged_slots,
                dataChanged: false,
                doctorUnavailabilityUpdated:
                  detailsObj.doctor_unavailability_data,
                visit_now_doctor_status: practiceDetailsObj.visit_now_doctor_status
              };

              const practiceDetail = {
                ...practiceDetails,
                copy: practiceDetails,
              };

              if (documentsObj) {
                const licenseDocName =
                  documentsObj.license_document &&
                  documentsObj.license_document.split("/").pop();

                const deaDocName =
                  documentsObj.dea_document &&
                  documentsObj.dea_document.split("/").pop();

                const insuranceDocName =
                  documentsObj.insurance_document &&
                  documentsObj.insurance_document.split("/").pop();

                const documents = {
                  id: documentsObj.id,
                  licenseStartDate: parseDateToLocal(
                    documentsObj.license_start_date
                  ),
                  licenseEndDate: parseDateToLocal(
                    documentsObj.license_end_date
                  ),
                  licenseNumber: documentsObj.license_number,
                  licenseState: getCountryState(documentsObj.license_state),

                  licenseDoc: documentsObj.license_document && [
                    {
                      name: licenseDocName.substr(
                        licenseDocName.indexOf("_") + 1
                      ),
                      src: documentsObj.license_document,
                    },
                  ],
                  deaStartDate: parseDateToLocal(documentsObj.dea_start_date),
                  deaEndDate: parseDateToLocal(documentsObj.dea_end_date),
                  deaNumber: documentsObj.dea_number,
                  deaState: getCountryState(documentsObj.dea_state),
                  deaDoc: documentsObj.dea_document && [
                    {
                      name: deaDocName.substr(deaDocName.indexOf("_") + 1),
                      src: documentsObj.dea_document,
                    },
                  ],
                  insuranceStartDate: parseDateToLocal(
                    documentsObj.insurance_start_date
                  ),
                  insuranceEndDate: parseDateToLocal(
                    documentsObj.insurance_end_date
                  ),
                  insuranceCompanyName: documentsObj.insurance_company_name,
                  insuranceState: getCountryState(documentsObj.insurance_state),
                  insuranceDoc: documentsObj.insurance_document && [
                    {
                      name: insuranceDocName.substr(
                        insuranceDocName.indexOf("_") + 1
                      ),
                      src: documentsObj.insurance_document,
                    },
                  ],
                  npiNumber: documentsObj.npi_number,
                  dataLoaded: true,
                  dataChanged: false,
                };

                const document = {
                  ...documents,
                  copy: documents,
                };

                if (
                  !localStorage.getItem("bankRedirect") ||
                  JSON.parse(localStorage.getItem("bankRedirect")) === false
                ) {
                  if (
                    practiceDetailsObj &&
                    documentsObj &&
                    bankDetailsObj &&
                    personalDetails?.dosespot_id &&
                    flag === "init"
                  ) {
                    if (!localStorage.getItem("profileCompleted")) {
                      localStorage.setItem("profileCompleted", true);
                      cb();
                    }
                    if (
                      getUserData()?.doctor_status &&
                      !["PENDING", "DENIED", "PROFILE_INCOMPLETE"].includes(
                        getUserData()?.doctor_status
                      )
                    )
                      dispatch(authInit(getOnboardingPath("/step1"), true));
                  }
                }

                updateUserData({
                  doctor_status: detailsObj?.status,
                  reason: detailsObj?.denial_reason,
                  dosespot_id: detailsObj?.dosespot_id,
                });
                dispatch(setPersonalInfo(personalDetail));
                dispatch(setPracticeDetails(practiceDetail));
                dispatch(setDocuments(document));
                bankDetailsObj &&
                  dispatch(
                    setAccountDetails({
                      bankDetails: bankDetailsObj,
                      is_subscription_exists:
                        detailsObj?.doctor_subscription_details?.length > 0,
                    })
                  );
                dispatch(
                  setPersonalisedExperience({
                    is_paid: detailsObj?.is_paid,
                  })
                );
                dispatch(
                  setAppointmentData({
                    noOfRequestedAppointments:
                      detailsObj?.requested_appointment_count,
                    noOfScheduledAppointments:
                      detailsObj?.scheduled_appointment_count,
                  })
                );
                !flag && cb();
              } else {
                dispatch(setPersonalInfo(personalDetail));
                dispatch(setPracticeDetails(practiceDetail));
              }
            } else {
              dispatch(setPersonalInfo(personalDetail));
            }
          }
          // cb();
        } else {
          errorHandler(res.message[0]);
        }
        localStorage.removeItem("loginLoading");
        dispatch(apiSuccess());
      })
      .catch(error => {
        console.log("error: ", error);
        catchHandler(error, dispatch);
      });
  };
};

export const saveDoctorPracticeDetails = cb => {
  return (dispatch, getState) => {
    const practiceDetails = getState().onboarding.practiceDetails;

    const fees = parseFloat(practiceDetails?.fees.replace("$", ""));

    const practice_address = [];

    practice_address.push({
      address1: practiceDetails.address1,
      address2:
        practiceDetails.address2?.length > 0
          ? practiceDetails.address2
          : undefined,
      zip_code: practiceDetails.zipcode,
      city: practiceDetails.city,
      country: practiceDetails.country,
      state: practiceDetails.state,
      latitude: practiceDetails.latitude.toFixed(11).toString(),
      longitude: practiceDetails.longitude.toFixed(8).toString(),
    });

    const availability_details = [];

    practiceDetails.calendar.forEach(cal => {
      const slots = [];

      if (cal.morningSlots.length > 0) {
        cal.morningSlots.forEach(slot => {
          slots.push({
            day_period: "MORNING",
            start_time: parseTimeToUTC(slot.startTime),
            end_time: parseTimeToUTC(slot.endTime),
            slot_duration: slot.duration.label,
          });
        });
      }
      if (cal.afternoonSlots.length > 0) {
        cal.afternoonSlots.forEach(slot => {
          slots.push({
            day_period: "AFTERNOON",
            start_time: parseTimeToUTC(slot.startTime),
            end_time: parseTimeToUTC(slot.endTime),
            slot_duration: slot.duration.label,
          });
        });
      }

      if (cal.eveningSlots.length > 0) {
        cal.eveningSlots.forEach(slot => {
          slots.push({
            day_period: "NIGHT",
            start_time: parseTimeToUTC(slot.startTime),
            end_time: parseTimeToUTC(slot.endTime),
            slot_duration: slot.duration.label,
          });
        });
      }

      const detialsObj = {
        start_date: parseDateToUTC(cal.startDate),
        end_date: parseDateToUTC(cal.endDate),
        week_days: cal.workingDays,
        slot_availability: slots,
      };
      availability_details.push(detialsObj);
    });

    const payload = {
      doctor_detail: getUserData().id,
      practice_name: practiceDetails.practiceName,
      fees: fees,
      primary_phone: practiceDetails.primaryPhone,
      primary_phone_type: practiceDetails?.primaryPhoneType?.value,
      primary_fax: practiceDetails.primaryFax,
      slot_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      practice_address: practice_address,
      availability_details: !practiceDetails.visit_now_doctor_status ? availability_details : [],
      visit_now_doctor_status: practiceDetails.visit_now_doctor_status
    };

    dispatch(apiStart());
    axios
      .post(urls.saveDoctorPracticeDetailsUrl, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(getDoctorDetails());

          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

const config = {
  bucketName: process.env.REACT_APP_BUCKET_NAME,
  dirName: process.env.REACT_APP_DIRECTORY_NAME_DOCTOR_DETAILS,
  region: process.env.REACT_APP_AWS_SECRET_REGION,
  accessKeyId: process.env.REACT_APP_BUCKET_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_BUCKET_AWS_SECRET_KEY,
  s3Url: process.env.REACT_APP_AWS_S3_URL,
};

const deleteConfig = {
  bucketName: process.env.REACT_APP_BUCKET_NAME,
  dirName: process.env.REACT_APP_DIRECTORY_NAME_DOCTOR_DETAILS,
  accessKeyId: process.env.REACT_APP_BUCKET_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_BUCKET_AWS_SECRET_KEY,
  s3Url: process.env.REACT_APP_AWS_S3_URL,
};

export const uploadFileToS3 = file => {
  if (file) {
    if (file !== "") {
      const fileName = file.name.split(".").slice(0, -1).join(".");

      var d = new Date();
      const newName =
        d.getTime().toString() + "_" + fileName.replaceAll(" ", "_");

      const S3Client = new S3(config);

      // S3Client.upload

      return S3Client.uploadFile(file, newName);
    } else {
      console.log("Not upload S3 error");
    }
  } else {
    return new Promise((resolve, reject) => resolve({ location: null }));
  }
};

export const deleteFileFromS3 = (file, cb = () => {}, showLoader = true) => {
  return dispatch => {
    if (file?.src) {
      showLoader && dispatch(apiStart());
      const fileName = file?.src.split("/").pop();
      const S3Clients = new S3(deleteConfig);

      S3Clients.deleteFile(fileName)
        .then(response => {
          cb();
          console.log("success deleted");
          dispatch(apiSuccess());
        })
        .catch(error => {
          console.log("error: " + error);
          errorHandler(error);
          dispatch(apiSuccess());
        });
    } else {
      console.log("Not deleted S3 error");
    }
  };
};

export const updateProfileImage = profile => {
  return (dispatch, getState) => {
    const personalInfo = getState().onboarding.personalInfo;

    dispatch(apiStart());

    const profileImage = uploadFileToS3(profile.photo.data);

    if (personalInfo?.photo?.src && profile?.photo) {
      dispatch(deleteFileFromS3(personalInfo.photo, () => {}));
    }

    profileImage
      .then(profileData => {
        axios
          .patch(urls.updateProfileImageUrl(getUserData().user), {
            image: profileData.location,
          })
          .then(response => {
            const res = response.data;
            if (res.status_code === 200) {
              dispatch(
                setPersonalInfo({
                  photo: { src: res.data.image },
                  copy: {
                    ...personalInfo.copy,
                    photo: { src: res.data.image },
                  },
                  dataChanged: personalInfo.dataChanged,
                })
              );
            } else {
              errorHandler(res.message[0]);
            }
            dispatch(apiSuccess());
          })
          .catch(error => {
            catchHandler(error, dispatch);
          });
      })
      .catch(err => {
        console.log(err);
        catchHandler("Profile Image upload failed");
      });
  };
};

export const updateDoctorSignature = (action, cb) => {
  return (dispatch, getState) => {
    const personalInfo = getState().onboarding.personalInfo;

    dispatch(apiStart());

    const signUpload = uploadFileToS3(
      (personalInfo.docsignature &&
        (personalInfo.docsignature[0]?.src
          ? undefined
          : personalInfo.docsignature[0])) ||
        undefined
    );

    signUpload
      .then(signatureData => {
        const payload = {
          signature:
            (personalInfo?.docsignature &&
              personalInfo?.docsignature[0]?.src) ||
            signatureData.location,
        };
        axios
          .patch(urls.updateDoctorSignatureUrl(getUserData().id), payload)
          .then(response => {
            const res = response.data;
            if (res.status_code === 200) {
              dispatch(getDoctorDetails());
              dispatch(
                setPersonalInfo({
                  docsignature: res.data?.signature && [
                    {
                      src: res.data?.signature,
                    },
                  ],
                  copy: {
                    ...personalInfo.copy,
                    docsignature: { src: res.data.signature },
                  },
                  dataChanged: personalInfo.dataChanged,
                })
              );
              successHandler(res.message[0]);
            } else {
              errorHandler(res.message[0]);
            }
            dispatch(apiSuccess());
          })
          .catch(error => {
            catchHandler(error, dispatch);
          });
      })
      .catch(err => {
        console.log(err);
        catchHandler("Signature upload failed");
      });
  };
};

export const updateDoctorDetail = (cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const personalDetails = getState().onboarding.personalInfo;
    const payload = {
      gender: personalDetails.gender,
      speciality: [
        personalDetails.specialities.map(specialities => specialities.label),
      ][0],
      years_of_experience: personalDetails.yearsOfExperience,
      about_me: personalDetails.aboutMe ? personalDetails.aboutMe : null,
      language: [personalDetails.languages.map(language => language.label)][0],
      degree: [personalDetails.degree.id],
      date_of_birth: parseDateToUTC(personalDetails.date_of_birth),
      doctor_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    const userPayload = {
      first_name: personalDetails.firstName,
      last_name: personalDetails.lastName,
    };
    axios
      .patch(urls.updateUserUrl(getUserData().user), userPayload)
      .then(userResponse => {
        const userRes = userResponse.data;
        if (userRes.status_code === 200) {
          dispatch(apiStart());
          axios
            .patch(urls.updateDoctorDetailUrl(getUserData().id), payload)
            .then(response => {
              const res = response.data;
              if (res.status_code === 200) {
                dispatch(
                  getDoctorDetails(false, () =>
                    personalDetails?.dosespot_id
                      ? dispatch(
                          updateClinicianProfile(personalDetails?.dosespot_id)
                        )
                      : cb()
                  )
                );
                successHandler(messages.PERSONAL_DETAILS_SUCCESS);
              } else {
                errorHandler(res.message[0]);
              }
              dispatch(apiSuccess());
            })
            .catch(error => {
              catchHandler(error, dispatch);
            });
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateDoctorPracticeDetails = (cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());

    const personalDetails = getState().onboarding.personalInfo;

    const practiceDetails = getState().onboarding.practiceDetails;

    const fees =
      practiceDetails?.fees &&
      parseFloat(
        practiceDetails?.fees.toString().replace("$", "").replace(",", "")
      );

    const practice_address = [];

    practice_address.push({
      id: practiceDetails.address_id,
      address1: practiceDetails.address1,
      address2: practiceDetails.address2,
      zip_code: practiceDetails.zipcode,
      city: practiceDetails.city,
      country: practiceDetails.country,
      state: practiceDetails.state,
      latitude: practiceDetails.latitude.toFixed(11).toString(),
      longitude: practiceDetails.longitude.toFixed(8).toString(),
    });
    const add_availability_details = [];
    const update_availability_details = [];

    const added_slots = [];
    practiceDetails.calendar.forEach(cal => {
      const slots = [];

      if (cal.morningSlots.length > 0) {
        cal.morningSlots.forEach(slot => {
          slot.id || !cal.id
            ? slots.push({
                id: slot?.id,
                day_period: "MORNING",
                start_time: parseTimeToUTC(slot.startTime),
                end_time: parseTimeToUTC(slot.endTime),
                slot_duration: slot.duration.label,
              })
            : added_slots.push({
                doctor_availability: cal?.id,
                day_period: "MORNING",
                start_time: parseTimeToUTC(slot.startTime),
                end_time: parseTimeToUTC(slot.endTime),
                slot_duration: slot.duration.label,
              });
        });
      }
      if (cal.afternoonSlots.length > 0) {
        cal.afternoonSlots.forEach(slot => {
          slot.id || !cal.id
            ? slots.push({
                id: slot?.id,
                day_period: "AFTERNOON",
                start_time: parseTimeToUTC(slot.startTime),
                end_time: parseTimeToUTC(slot.endTime),
                slot_duration: slot.duration.label,
              })
            : added_slots.push({
                doctor_availability: cal.id,
                day_period: "AFTERNOON",
                start_time: parseTimeToUTC(slot.startTime),
                end_time: parseTimeToUTC(slot.endTime),
                slot_duration: slot.duration.label,
              });
        });
      }

      if (cal.eveningSlots.length > 0) {
        cal.eveningSlots.forEach(slot => {
          slot.id || !cal.id
            ? slots.push({
                id: slot?.id,
                day_period: "NIGHT",
                start_time: parseTimeToUTC(slot.startTime),
                end_time: parseTimeToUTC(slot.endTime),
                slot_duration: slot.duration.label,
              })
            : added_slots.push({
                doctor_availability: cal.id,
                day_period: "NIGHT",
                start_time: parseTimeToUTC(slot.startTime),
                end_time: parseTimeToUTC(slot.endTime),
                slot_duration: slot.duration.label,
              });
        });
      }
      cal.id
        ? update_availability_details.push({
            id: cal.id,
            start_date: parseDateToUTC(cal.startDate),
            end_date: parseDateToUTC(cal.endDate),
            week_days: cal.workingDays,
            slot_availability: slots,
          })
        : add_availability_details.push({
            start_date: parseDateToUTC(cal.startDate),
            end_date: parseDateToUTC(cal.endDate),
            week_days: cal.workingDays,
            slot_availability: slots,
          });
    });

    let payload = {
      doctor_detail: getUserData().id,
      practice_name: practiceDetails.practiceName,
      fees: fees,
      primary_phone: practiceDetails.primaryPhone,
      primary_phone_type: practiceDetails?.primaryPhoneType?.value,
      primary_fax: practiceDetails.primaryFax,
      slot_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      update_practice_address: practice_address,
      update_availability: update_availability_details,
      delete_availability: practiceDetails.removedCalendar,
      add_practice_address: [],
      delete_practice_address: [],
      delete_slot_availability: practiceDetails.removedSlots,
      add_slot_availability: added_slots,
      visit_now_doctor_status: practiceDetails?.visit_now_doctor_status || false,
    };

    if (!practiceDetails?.visit_now_doctor_status) {
      payload["add_availability"] = add_availability_details;
    }

    axios
      .patch(
        urls.updateDoctorPracticeDetailsUrl(practiceDetails.practice_detail),
        payload
      )
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(
            getDoctorDetails(false, () =>
              personalDetails?.dosespot_id
                ? dispatch(updateClinicianProfile(personalDetails?.dosespot_id))
                : cb()
            )
          );
          successHandler(messages.PRACTICE_DETAILS_SUCCESS);
        } else {
          errorHandler(Array.isArray(res.message[0])? res.message[0] : res.message);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateDoctorDocuments = (action, cb = () => {}) => {
  return (dispatch, getState) => {
    const personalDetails = getState()?.onboarding?.personalInfo;
    const documents = getState().onboarding.documents;
    const practiceDetailId =
      getState().onboarding.practiceDetails.practice_detail;

    dispatch(apiStart());

    const licenseDocUrl = uploadFileToS3(
      (documents.licenseDoc &&
        (documents.licenseDoc[0]?.src ? undefined : documents.licenseDoc[0])) ||
        undefined
    );
    const deaDocUrl = uploadFileToS3(
      (documents.deaDoc &&
        (documents.deaDoc[0]?.src ? undefined : documents.deaDoc[0])) ||
        undefined
    );
    const insuranceDocUrl = uploadFileToS3(
      (documents.insuranceDoc &&
        (documents.insuranceDoc[0]?.src
          ? undefined
          : documents.insuranceDoc[0])) ||
        undefined
    );
    licenseDocUrl
      .then(licenseData => {
        deaDocUrl
          .then(deaData => {
            insuranceDocUrl
              .then(insuranceData => {
                const payload = {
                  practice_detail: practiceDetailId,
                  npi_number: documents.npiNumber,
                  license_document:
                    (documents.licenseDoc && documents?.licenseDoc[0]?.src) ||
                    licenseData.location,
                  license_number: documents.licenseNumber,
                  license_state: documents.licenseState?.value,
                  license_start_date: parseDateToUTC(
                    documents.licenseStartDate
                  ),
                  license_end_date: parseDateToUTC(documents.licenseEndDate),
                  dea_document:
                    (documents.deaDoc && documents?.deaDoc[0]?.src) ||
                    deaData.location,
                  dea_number: documents.deaNumber,
                  dea_state: documents.deaState?.value,
                  dea_start_date: parseDateToUTC(documents.deaStartDate),
                  dea_end_date: parseDateToUTC(documents.deaEndDate),
                  insurance_document:
                    (documents.insuranceDoc &&
                      documents?.insuranceDoc[0]?.src) ||
                    insuranceData.location,
                  insurance_start_date: parseDateToUTC(
                    documents.insuranceStartDate
                  ),
                  insurance_end_date: parseDateToUTC(
                    documents.insuranceEndDate
                  ),
                  insurance_company_name: documents.insuranceCompanyName,
                  insurance_state: documents.insuranceState?.value,
                };

                action === "update"
                  ? axios
                      .patch(
                        urls.updateDoctorDocumentUrl(documents.id),
                        payload
                      )
                      .then(response => {
                        const res = response.data;
                        if (res.status_code === 200) {
                          dispatch(
                            getDoctorDetails(false, () =>
                              personalDetails?.dosespot_id
                                ? dispatch(
                                    updateClinicianProfile(
                                      personalDetails?.dosespot_id
                                    )
                                  )
                                : cb()
                            )
                          );
                          successHandler(messages.DOCUMENT_DETAILS_SUCCESS);
                          // cb();
                        } else {
                          errorHandler(res.message[0]);
                        }
                        dispatch(apiSuccess());
                      })
                      .catch(error => {
                        catchHandler(error, dispatch);
                      })
                  : axios
                      .post(urls.saveDoctorDocumentUrl, payload)
                      .then(response => {
                        const res = response.data;
                        if (res.status_code === 200) {
                          dispatch(getDoctorDetails());
                          cb();
                        } else {
                          errorHandler(res.message[0]);
                        }
                        dispatch(apiSuccess());
                      })
                      .catch(error => {
                        catchHandler(error, dispatch);
                      });
              })
              .catch(err => {
                console.log(err);
                catchHandler("Insurance Document upload failed");
              });
          })
          .catch(err => {
            console.log(err);
            catchHandler("DEA Document upload failed");
          });
      })
      .catch(err => {
        console.log(err);
        catchHandler("License Document upload failed");
      });
  };
};

export const updateDoctorAppTheme = (action, cb) => {
  return (dispatch, getState) => {
    const userData = getUserData();

    const personalisedExperience = getState().onboarding.personalisedExperience;
    dispatch(apiStart());

    const logoUpload = uploadFileToS3(
      (personalisedExperience.logo &&
        (personalisedExperience.logo[0]?.src
          ? undefined
          : personalisedExperience.logo[0])) ||
        undefined
    );

    logoUpload
      .then(logoData => {
        const payload = {
          doctor: userData?.id,
          logo_url:
            (personalisedExperience.logo &&
              personalisedExperience?.logo[0]?.src) ||
            logoData.location,
          app_theme: personalisedExperience.selectedThemeId
            ? personalisedExperience.selectedThemeId
            : 1,
        };

        action === "update" && personalisedExperience?.id
          ? axios
              .patch(
                urls.updateDoctorAppThemeUrl(personalisedExperience?.id),
                payload
              )
              .then(response => {
                const res = response.data;
                if (res.status_code === 200) {
                  // cb();
                  dispatch(getDoctorAppTheme());
                  updateUserData({
                    user_theme: personalisedExperience.theme_name,
                    logo_url: res?.data?.logo_url || null,
                  });
                  successHandler(messages.PERSONALISED_DETAILS_SUCCESS);
                } else {
                  errorHandler(res.message[0]);
                }
                dispatch(apiSuccess());
              })
              .catch(error => {
                catchHandler(error, dispatch);
              })
          : axios
              .post(urls.addDoctorAppThemeUrl, payload)
              .then(response => {
                const res = response.data;
                if (res.status_code === 200) {
                  dispatch(getDoctorAppTheme());
                  updateUserData({
                    user_theme: personalisedExperience.theme_name,
                    logo_url: res?.data?.logo_url || null,
                  });
                  successHandler(messages.PERSONALISED_DETAILS_SUCCESS);
                  // cb();
                } else {
                  errorHandler(res.message[0]);
                }
                dispatch(apiSuccess());
              })
              .catch(error => {
                catchHandler(error, dispatch);
              });
      })
      .catch(err => {
        console.log(err);
        catchHandler("Profile Image upload failed");
      });
  };
};

export const updateDoctorStatus = (payload, cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(apiStart());
    api
      .updatePhysicianStatus(getUserData()?.id, payload)
      .then(response => {
        const res = response;
        if (res.status === 200) {
          getUserData()?.doctor_status !== "PROFILE_INCOMPLETE" &&
            successHandler(`Profile Successfully Submitted`);
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export const updateDoctorQrCode = (downloadLink, cb = () => {}) => {
  return (dispatch, getState) => {
    const personalInfo = getState().onboarding.personalInfo;

    dispatch(apiStart());

    const dataFile = dataURLtoFile(
      downloadLink,
      getUserData().firstName +
        "_" +
        getUserData().lastName +
        getUserData().id +
        ".png"
    );

    const qrCodeUpload = uploadFileToS3(dataFile);

    qrCodeUpload
      .then(QrData => {
        const payload = {
          qrcode_url: QrData.location,
        };
        axios
          .patch(urls.updateDoctorQrCodeUrl(getUserData().id), payload)
          .then(response => {
            const res = response.data;
            if (res.status_code === 200) {
              console.log(res.data);
              updateUserData({
                qrcode_url: res.data?.qrcode_url,
              });

              dispatch(
                setPersonalInfo({
                  qrcode_url: res.data?.qrcode_url,
                  copy: {
                    ...personalInfo.copy,
                    qrcode_url: res.data.qrcode_url,
                  },
                  dataChanged: personalInfo.dataChanged,
                })
              );
            } else {
            }
            dispatch(apiSuccess());
          })
          .catch(error => {
            catchHandler(error, dispatch);
          });
      })
      .catch(err => {
        console.log(err);
      });
  };
};
